exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-04adf011]{white-space:normal;word-break:break-word}img[data-v-04adf011]{margin:0 auto}\n", ""]);

// exports
